import { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export type AlertTone = "info" | "warn" | "danger" | "success";

const toneClasses: Record<AlertTone, string> = {
  info: "bg-accent/10 text-fg border-accent/40",
  warn: "bg-warn/10 text-fg border-warn/40",
  danger: "bg-bad/10 text-fg border-bad/40",
  success: "bg-good/10 text-fg border-good/40",
};

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  tone?: AlertTone;
  title?: string;
}

export function Alert({ className, tone = "info", title, children, ...props }: AlertProps) {
  return (
    <div
      className={cn("rounded-md border p-3 text-sm", toneClasses[tone], className)}
      role="alert"
      {...props}
    >
      {title && <div className="font-semibold mb-0.5">{title}</div>}
      <div className={title ? "text-muted" : ""}>{children}</div>
    </div>
  );
}
